import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import {
  getOrderId,
  checkMMRPApi,
  addProductApi,
  deleteItemApi,
  generateReadyToInvoice,
  applyCouponApi,
  verifyPaymentApi,
  checkTransactionStatusApi,
  fetchAllOrdersApi,
  addBagApi,
  removeBagApi,
  fetchFreebiesApi,
  removeCouponApi,
  addFreebieApi,
  removeFreebieApi,
  eliteMembershipSubscriptionApi,
  requestTxnTokenApi,
  fetchPromosApi,
} from '../api/order.api';
import {lmrRedeemDataApi} from '../api/lmrredeemdata.api';
import {RootState} from './store';
import {
  OrderResponse,
  MMRPResponse,
  orderRequest,
  MMRPRequest,
  AddProductRequest,
  DeleteItemRequest,
  ApplyCouponRequest,
  InvoiceRequest,
  VerifyPaymentRequest,
  PaymentStatus,
  InvoiceResponse,
  CheckStatusResponse,
  Notification,
  AddBagRequest,
  AddFreebieRequest,
  TxnTokenObject,
  PromosRequest,
  invoiceErrorResponse,
  lmrRedeemDataRequest,
} from '../lib/order-types';
import {setTotalCartItems} from '../core/localstorage-data';

interface orderState {
  orderResponse: OrderResponse | null;
  addProductResponse: OrderResponse | null;
  deleteItemResponse: OrderResponse | null;
  mmrpResponse: MMRPResponse | null;
  invoiceGeneratedResponse: InvoiceResponse | null;
  invoiceGeneratedLoading: boolean;
  invoiceGeneratedError: invoiceErrorResponse | null;
  loading: boolean;
  error: string;
  orderAddBagResponse: OrderResponse | null;
  orderAddBagLoading: boolean;
  orderAddBagError: string;
  orderRemoveBagResponse: OrderResponse | null;
  orderRemoveBagLoading: boolean;
  orderRemoveBagError: string;
  orderId: string;
  isPriceMatched: boolean;
  paymentStatus: PaymentStatus | null;
  paymentStatusError: string;
  paymentStatusLoading: boolean;
  transactionStatusResponse: CheckStatusResponse | null;
  transactionStatusResponseLoading: boolean;
  transactionStatusError: string;
  allOrders: OrderResponse[] | null;
  couponApplied: boolean;
  notification: Notification | null;
  loaderType: string;
  cartItemsCount: number;
  eliteResponse: OrderResponse | null;
  txnToken: TxnTokenObject | null;
  lmrChecked: boolean;
  lmrRedeemDataOrderResponse: OrderResponse | null;
  lmrRedeemDataOrderResponseError: string;
  lmrRedeemDataOrderResponseLoading: boolean;
}

const initialState: orderState = {
  orderResponse: null,
  addProductResponse: null,
  deleteItemResponse: null,
  invoiceGeneratedResponse: null,
  invoiceGeneratedLoading: false,
  invoiceGeneratedError: null,
  orderAddBagResponse: null,
  orderAddBagLoading: false,
  orderAddBagError: '',
  orderRemoveBagResponse: null,
  orderRemoveBagLoading: false,
  orderRemoveBagError: '',
  mmrpResponse: null,
  loading: false,
  error: '',
  orderId: '',
  isPriceMatched: false,
  paymentStatus: null,
  paymentStatusError: '',
  paymentStatusLoading: false,
  transactionStatusResponse: null,
  transactionStatusResponseLoading: false,
  transactionStatusError: '',
  allOrders: null,
  couponApplied: false,
  notification: null,
  loaderType: '',
  cartItemsCount: 0,
  eliteResponse: null,
  txnToken: null,
  lmrChecked: false,
  lmrRedeemDataOrderResponse: null,
  lmrRedeemDataOrderResponseError: '',
  lmrRedeemDataOrderResponseLoading: false,
};

export const fetchOrder = createAsyncThunk(
  'order/fetchOrder',
  async (parameters: orderRequest, thunkApi) => {
    return getOrderId(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const checkMMRP = createAsyncThunk(
  'order/checkMMRP',
  async (parameters: MMRPRequest, thunkApi) => {
    return checkMMRPApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const addProduct = createAsyncThunk(
  'order/addProduct',
  async (parameters: AddProductRequest, thunkApi) => {
    return addProductApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const deleteItem = createAsyncThunk(
  'order/deleteItem',
  async (parameters: DeleteItemRequest, thunkApi) => {
    return deleteItemApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const generateInvoice = createAsyncThunk(
  'order/generateInvoice',
  async (parameters: InvoiceRequest, thunkApi) => {
    try {
      const response = await generateReadyToInvoice(parameters);
      console.log(response);
      return response;
    } catch (error) {
      console.log('sagar garg');
      //   console.log(JSON.stringify(error.response.data));
      // console.log(error);
      console.log(error);
      console.log(error.response.data);
      return thunkApi.rejectWithValue(error.response.data);
      //   return 0;
    }
  },
);
export const applyCoupon = createAsyncThunk(
  'order/applyCoupon',
  async (parameters: ApplyCouponRequest, thunkApi) => {
    return applyCouponApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const removeCoupon = createAsyncThunk(
  'order/removeCoupon',
  async (parameters: InvoiceRequest, thunkApi) => {
    return removeCouponApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const fetchFreebies = createAsyncThunk(
  'order/fetchFreebies',
  async (parameters: InvoiceRequest, thunkApi) => {
    return fetchFreebiesApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const addFreebie = createAsyncThunk(
  'order/addFreebie',
  async (parameters: AddFreebieRequest, thunkApi) => {
    return addFreebieApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const removeFreebie = createAsyncThunk(
  'order/removeFreebie',
  async (parameters: InvoiceRequest, thunkApi) => {
    return removeFreebieApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const addBag = createAsyncThunk(
  'order/addBag',
  async (parameters: AddBagRequest, thunkApi) => {
    return addBagApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const removeBag = createAsyncThunk(
  'order/removeBag',
  async (parameters: AddBagRequest, thunkApi) => {
    return removeBagApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const verifyPaymentStatus = createAsyncThunk(
  'checkout/verifyPayment',
  async (parameters: VerifyPaymentRequest, thunkApi) => {
    return verifyPaymentApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const checkTransactionStatus = createAsyncThunk(
  'checkout/checkTransactionStatus',
  async (parameters: InvoiceRequest, thunkApi) => {
    return checkTransactionStatusApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const fetchAllOrders = createAsyncThunk(
  'checkout/fetchAllOrders',
  async (accessToken: string, thunkApi) => {
    return fetchAllOrdersApi(accessToken)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const eliteMembershipSubscription = createAsyncThunk(
  'checkout/eliteMembershipSubscription',
  async (accessToken: string, thunkApi) => {
    return eliteMembershipSubscriptionApi(accessToken)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const requestTxnToken = createAsyncThunk(
  'checkout/requestTxnToken',
  async (parameters: InvoiceRequest, thunkApi) => {
    return requestTxnTokenApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const fetchPromos = createAsyncThunk(
  'checkout/fetchPromos',
  async (parameters: PromosRequest, thunkApi) => {
    return fetchPromosApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error);
      });
  },
);

export const lmrRedeemData = createAsyncThunk(
  'order/redeem-lmr',
  async (parameters: lmrRedeemDataRequest, thunkApi) => {
    return lmrRedeemDataApi(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error);
      });
  },
);

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setIsPriceMatched: (state, action: PayloadAction<boolean>) => {
      state.isPriceMatched = action.payload;
    },
    resetOrderState: () => initialState,
    resetMMRPState: state => {
      state.mmrpResponse = null;
      state.error = '';
    },
    resetAddproductState: state => {
      state.addProductResponse = null;
      state.error = '';
    },
    resetAddBagResponse: state => {
      state.orderAddBagResponse = null;

      state.orderAddBagError = '';
    },
    resetRemoveBagResponse: state => {
      state.orderRemoveBagResponse = null;
      state.orderRemoveBagError = '';
    },
    resetInvoiceResponse: state => {
      console.log('RESETTING INVOICE');
      state.invoiceGeneratedResponse = null;

      state.invoiceGeneratedError = null;
    },
    resetTransactionResponse: state => {
      state.transactionStatusResponse = null;

      state.transactionStatusError = '';
    },

    setCouponApplied: (state, action: PayloadAction<boolean>) => {
      state.couponApplied = action.payload;
    },
    resetNotification: state => {
      state.notification = null;
    },
    resetCouponApplied: state => {
      state.couponApplied = false;
    },
    setLoaderType: (state, action: PayloadAction<string>) => {
      state.loaderType = action.payload;
    },
    setCartItemsCount: (state, action: PayloadAction<number>) => {
      state.cartItemsCount = action.payload;
    },
    setLmrChecked: (state, action: PayloadAction<boolean>) => {
      state.lmrChecked = action.payload;
    },
    setTxnToken: (state, action: PayloadAction<TxnTokenObject>) => {
      state.txnToken = action.payload;
    },
    resetPaymentStatus: state => {
      state.paymentStatus = null;
      state.paymentStatusError = '';
      state.paymentStatusLoading = false;
    },
    resetTxnToken: state => {
      state.txnToken = null;
    },
    resetLmrRedeemDataResponse: state => {
      state.lmrRedeemDataOrderResponse = null;
      state.lmrRedeemDataOrderResponseError = '';
      state.lmrRedeemDataOrderResponseLoading = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(generateInvoice.pending, state => {
      state.invoiceGeneratedLoading = true;
      console.log('generate invoice data is loading    ');
    });
    builder.addCase(generateInvoice.fulfilled, (state, action) => {
      console.log('generate invoice data has come    ');
      state.invoiceGeneratedLoading = false;
      console.log(action.payload);
      state.invoiceGeneratedResponse = action.payload;
    });
    builder.addCase(generateInvoice.rejected, (state, action) => {
      console.log('generate invoice data has GOT ERROR understood    ');
      state.invoiceGeneratedError = action.payload;
      console.log(typeof action);
      console.log(JSON.stringify(action));
      console.log(state.invoiceGeneratedError);
      console.log(typeof state.invoiceGeneratedError);
      state.invoiceGeneratedLoading = false;
    });
    builder.addCase(fetchOrder.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.orderResponse = action.payload;
      state.cartItemsCount = action.payload.itemList
        ? action.payload.itemList.length
        : 0;
      state.orderId = action.payload.orderId;
      state.error = '';
      setTotalCartItems(
        action.payload.itemList ? action.payload.itemList.length : 0,
      );
    });
    builder.addCase(fetchOrder.rejected, (state, action) => {
      console.log('action errroor = ', action);
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(checkMMRP.pending, state => {
      state.loading = true;
    });
    builder.addCase(checkMMRP.fulfilled, (state, action) => {
      state.loading = false;
      state.mmrpResponse = action.payload;
      state.error = '';
    });
    builder.addCase(checkMMRP.rejected, (state, action) => {
      console.log('action');
      state.error =
        action.error.message || 'Something went wrong, Please try again.';
      state.loading = false;
    });
    builder.addCase(addProduct.pending, state => {
      state.loading = true;
    });
    builder.addCase(addProduct.fulfilled, (state, action) => {
      state.loading = false;
      //   state.orderResponse = action.payload;
      state.addProductResponse = action.payload;
      state.cartItemsCount = action.payload.itemList
        ? action.payload.itemList.length
        : 0;
      state.error = '';
      setTotalCartItems(
        action.payload.itemList ? action.payload.itemList.length : 0,
      );
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(deleteItem.pending, state => {
      state.loading = true;
    });
    builder.addCase(deleteItem.fulfilled, (state, action) => {
      state.loading = false;
      // state.deleteItemResponse = action.payload;
      state.orderResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.cartItemsCount = action.payload.itemList
        ? action.payload.itemList.length
        : 0;
      state.error = '';
      setTotalCartItems(
        action.payload.itemList ? action.payload.itemList.length : 0,
      );
    });
    builder.addCase(deleteItem.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(applyCoupon.pending, state => {
      state.loading = true;
    });
    builder.addCase(applyCoupon.fulfilled, (state, action) => {
      state.loading = false;
      // state.deleteItemResponse = action.payload;
      state.orderResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.error = '';
    });
    builder.addCase(applyCoupon.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(removeCoupon.pending, state => {
      state.loading = true;
    });
    builder.addCase(removeCoupon.fulfilled, (state, action) => {
      state.loading = false;
      // state.deleteItemResponse = action.payload;
      state.orderResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.error = '';
    });
    builder.addCase(removeCoupon.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(addBag.pending, state => {
      //state.loading = true;
      state.orderAddBagLoading = true;
    });
    builder.addCase(addBag.fulfilled, (state, action) => {
      //state.loading = false;
      //state.orderResponse = action.payload;
      //   state.error = '';
      state.orderAddBagLoading = false;
      state.orderAddBagResponse = action.payload;
      state.orderAddBagError = '';
    });
    builder.addCase(addBag.rejected, (state, action) => {
      //    state.error = action.toString();
      //  state.loading = false;
      state.orderAddBagError = action.toString();
      state.orderAddBagLoading = false;
    });
    builder.addCase(removeBag.pending, state => {
      //state.loading = true;
      state.orderRemoveBagLoading = true;
    });
    builder.addCase(removeBag.fulfilled, (state, action) => {
      // state.loading = false;
      // state.orderResponse = action.payload;
      // state.error = '';
      state.orderRemoveBagLoading = false;
      state.orderRemoveBagResponse = action.payload;
      state.orderRemoveBagError = '';
    });
    builder.addCase(removeBag.rejected, (state, action) => {
      // state.error = action.toString();
      // state.loading = false;
      state.orderRemoveBagError = action.toString();
      state.orderRemoveBagLoading = false;
    });
    builder.addCase(fetchFreebies.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchFreebies.fulfilled, (state, action) => {
      state.loading = false;
      state.orderResponse = action.payload;
      state.error = '';
    });
    builder.addCase(fetchFreebies.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(addFreebie.pending, state => {
      state.loading = true;
    });
    builder.addCase(addFreebie.fulfilled, (state, action) => {
      state.loading = false;
      state.orderResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.error = '';
      setTotalCartItems(
        action.payload.itemList ? action.payload.itemList.length : 0,
      );
    });
    builder.addCase(addFreebie.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(removeFreebie.pending, state => {
      state.loading = true;
    });
    builder.addCase(removeFreebie.fulfilled, (state, action) => {
      state.loading = false;
      state.orderResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.error = '';
      setTotalCartItems(
        action.payload.itemList ? action.payload.itemList.length : 0,
      );
    });
    builder.addCase(removeFreebie.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(requestTxnToken.pending, state => {
      state.loading = true;
    });
    builder.addCase(requestTxnToken.fulfilled, (state, action) => {
      state.loading = false;
      state.txnToken = action.payload.body.txnToken
        ? {
            txnToken: action.payload.body.txnToken,
            status: 'S',
            paymentOrderId: action.payload.paymentOrderId,
          }
        : {
            txnToken: action.payload.body.txnToken,
            status: 'F',
            paymentOrderId: action.payload.paymentOrderId,
          };
      state.error = '';
    });
    builder.addCase(requestTxnToken.rejected, (state, action) => {
      state.txnToken = {
        txnToken: "",
        status: 'invalid-order',
        paymentOrderId: "",
      };
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(verifyPaymentStatus.pending, state => {
      state.paymentStatusLoading = true;
    });
    builder.addCase(verifyPaymentStatus.fulfilled, (state, action) => {
      state.paymentStatusLoading = false;
      state.paymentStatus = action.payload;
      state.paymentStatusError = '';
    });
    builder.addCase(verifyPaymentStatus.rejected, (state, action) => {
      state.paymentStatusError = action.toString();
      state.paymentStatusLoading = false;
    });
    builder.addCase(checkTransactionStatus.pending, state => {
      state.transactionStatusResponseLoading = true;
    });
    builder.addCase(checkTransactionStatus.fulfilled, (state, action) => {
      state.transactionStatusResponseLoading = false;
      // state.deleteItemResponse = action.payload;
      state.transactionStatusResponse = action.payload;
      state.transactionStatusError = '';
    });
    builder.addCase(checkTransactionStatus.rejected, (state, action) => {
      state.transactionStatusError = action.toString();
      state.transactionStatusResponseLoading = false;
    });
    builder.addCase(fetchAllOrders.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchAllOrders.fulfilled, (state, action) => {
      state.loading = false;
      // state.deleteItemResponse = action.payload;
      state.allOrders = action.payload;
      state.error = '';
    });
    builder.addCase(fetchAllOrders.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(eliteMembershipSubscription.pending, state => {
      state.loading = true;
    });
    builder.addCase(eliteMembershipSubscription.fulfilled, (state, action) => {
      state.loading = false;
      state.eliteResponse = action.payload;
      state.notification = {
        statusCode: action.payload.statusCode,
        statusMsg: action.payload.statusMessage,
      };
      state.error = '';
    });
    builder.addCase(eliteMembershipSubscription.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(fetchPromos.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchPromos.fulfilled, (state, action) => {
      state.loading = false;
      state.orderResponse = action.payload;
      state.error = '';
    });
    builder.addCase(fetchPromos.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
    builder.addCase(lmrRedeemData.pending, state => {
      state.lmrRedeemDataOrderResponseLoading = true;
    });
    builder.addCase(lmrRedeemData.fulfilled, (state, action) => {
      state.lmrRedeemDataOrderResponseLoading = false;
      state.lmrRedeemDataOrderResponse = action.payload;
      state.lmrRedeemDataOrderResponseError = '';
    });
    builder.addCase(lmrRedeemData.rejected, (state, action) => {
      state.lmrRedeemDataOrderResponseError = action.toString();
      state.lmrRedeemDataOrderResponseLoading = false;
    });
  },
});

export const {
  setIsPriceMatched,
  resetOrderState,
  resetMMRPState,
  resetAddproductState,
  resetInvoiceResponse,
  resetTransactionResponse,
  resetAddBagResponse,
  setCouponApplied,
  resetNotification,
  resetCouponApplied,
  setLoaderType,
  setCartItemsCount,
  setTxnToken,
  resetPaymentStatus,
  resetTxnToken,
  setLmrChecked,
  resetRemoveBagResponse,
  resetLmrRedeemDataResponse,
} = orderSlice.actions;

// export const offers = (state: RootState): coupon[] | null =>
//   state.offerReducer.offers;
export const orderResponse = (state: RootState): OrderResponse | null =>
  state.orderReducer.orderResponse;
export const orderRemoveBagResponse = (
  state: RootState,
): OrderResponse | null => state.orderReducer.orderRemoveBagResponse;
export const orderRemoveBagLoading = (state: RootState): boolean =>
  state.orderReducer.orderRemoveBagLoading;
export const orderRemoveBagError = (state: RootState): string =>
  state.orderReducer.orderRemoveBagError;

export const orderAddBagResponse = (state: RootState): OrderResponse | null =>
  state.orderReducer.orderAddBagResponse;
export const orderAddBagLoading = (state: RootState): boolean =>
  state.orderReducer.orderAddBagLoading;
export const orderAddBagError = (state: RootState): string =>
  state.orderReducer.orderAddBagError;
export const addProductResponse = (state: RootState): OrderResponse | null =>
  state.orderReducer.addProductResponse;
export const deleteItemResponse = (state: RootState): OrderResponse | null =>
  state.orderReducer.deleteItemResponse;
export const mmrpResponse = (state: RootState): MMRPResponse | null =>
  state.orderReducer.mmrpResponse;
export const mmrpError = (state: RootState): string => state.orderReducer.error;
export const invoiceGeneratedResponse = (
  state: RootState,
): InvoiceResponse | null => state.orderReducer.invoiceGeneratedResponse;
export const invoiceGeneratedError = (
  state: RootState,
): invoiceErrorResponse | null => state.orderReducer.invoiceGeneratedError;
export const invoiceGeneratedLoading = (state: RootState): boolean =>
  state.orderReducer.invoiceGeneratedLoading;
export const paymentStatus = (state: RootState): PaymentStatus | null =>
  state.orderReducer.paymentStatus;

export const paymentStatusError = (state: RootState): string =>
  state.orderReducer.paymentStatusError;
export const paymentStatusLoading = (state: RootState): boolean =>
  state.orderReducer.paymentStatusLoading;
export const transactionStatusResponse = (
  state: RootState,
): CheckStatusResponse | null => state.orderReducer.transactionStatusResponse;

export const transactionStatusResponseLoading = (state: RootState): boolean =>
  state.orderReducer.transactionStatusResponseLoading;
export const transactionStatusError = (state: RootState): string =>
  state.orderReducer.transactionStatusError;
export const allOrders = (state: RootState): OrderResponse[] | null =>
  state.orderReducer.allOrders;
export const couponApplied = (state: RootState): boolean | null =>
  state.orderReducer.couponApplied;
export const notification = (state: RootState): Notification | null =>
  state.orderReducer.notification;
export const loaderType = (state: RootState): string =>
  state.orderReducer.loaderType;
export const cartItemsCount = (state: RootState): number =>
  state.orderReducer.cartItemsCount;
export const eliteResponse = (state: RootState): OrderResponse | null =>
  state.orderReducer.eliteResponse;
export const txnToken = (state: RootState): TxnTokenObject | null =>
  state.orderReducer.txnToken;
export const lmrCheckedData = (state: RootState): boolean =>
  state.orderReducer.lmrChecked;
export const lmrRedeemDataResp = (state: RootState): OrderResponse | null =>
  state.orderReducer.lmrRedeemDataOrderResponse;
export const lmrRedeemDataError = (state: RootState): string =>
  state.orderReducer.lmrRedeemDataOrderResponseError;
export const lmrRedeemDataLoading = (state: RootState): boolean =>
  state.orderReducer.lmrRedeemDataOrderResponseLoading;

export default orderSlice.reducer;
